/**
 * Runtime Environment Variables
 *
 * For S3 deployments - values computed at runtime based on domain.
 * Based on: recruiter-ui/app/runtimeEnvVars.js
 */

import { domainMeta } from '@/utils/domain-meta';

export const WX_NAVBAR_VERSION = 'v3';

export const WX_NAVBAR_RELEASE_CHANNEL: string =
  import.meta.env.VITE_WX_NAVBAR_RELEASE_CHANNEL ??
  (domainMeta.environment === 'prod' ? 'stable' : 'main');

export const WX_NAVBAR_URL: string =
  import.meta.env.VITE_WX_NAVBAR_URL ??
  `https://ftn-shared-components.fountain.com/wx-navbar/${WX_NAVBAR_VERSION}/release/${WX_NAVBAR_RELEASE_CHANNEL}/wx-navbar.umd.js`;

export const WX_COPILOT_VERSION = 'v9';

export const WX_COPILOT_RELEASE_CHANNEL: string =
  import.meta.env.VITE_WX_COPILOT_RELEASE_CHANNEL ??
  (domainMeta.environment === 'prod' ? 'stable' : 'main');

export const WX_COPILOT_URL: string =
  import.meta.env.VITE_WX_COPILOT_URL ??
  `https://ftn-shared-components.fountain.com/wx-copilot/${WX_COPILOT_VERSION}/release/${WX_COPILOT_RELEASE_CHANNEL}/wx-copilot.umd.js`;

export const WX_LAUNCH_DARKLY_CLIENT_SIDE_ID: string =
  import.meta.env.VITE_WX_LAUNCH_DARKLY_CLIENT_SIDE_ID ??
  domainMeta.launchDarklyClientSideId;

export const I18N_LOG_MISSING_TRANSLATIONS =
  import.meta.env.VITE_I18N_LOG_MISSING_TRANSLATIONS ?? 'false';

export const POSTHOG_HOST: string =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? '';
export const POSTHOG_API_KEY: string =
  (import.meta.env.VITE_POSTHOG_API_KEY as string | undefined) ?? '';
export const POSTHOG_DEBUG: string =
  (import.meta.env.VITE_POSTHOG_DEBUG as string | undefined) ?? '';

export const SENTRY_DSN: string =
  (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '';
export const SENTRY_TRACES_SAMPLE_RATE: string =
  (import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as string | undefined) ?? '';
export const SENTRY_PROFILES_SAMPLE_RATE: string =
  (import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE as string | undefined) ??
  '';
export const SENTRY_REPLAYS_SESSION_SAMPLE_RATE: string =
  (import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE as
    | string
    | undefined) ?? '';
export const SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: string =
  (import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE as
    | string
    | undefined) ?? '';
export const SENTRY_LOGS_ENABLED: string =
  (import.meta.env.VITE_SENTRY_LOGS_ENABLED as string | undefined) ?? '';

// The full 40-character commit sha, set by the `build` script from the same
// SOURCE_VERSION the other frontends' builds read. Empty outside a build.
export const GIT_COMMIT_SHA: string =
  (import.meta.env.VITE_GIT_COMMIT_SHA as string | undefined) ?? '';
